/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ServiceFeeConfigurationCreateRequest } from '../models/ServiceFeeConfigurationCreateRequest';
import type { ServiceFeeConfigurationUpdateRequest } from '../models/ServiceFeeConfigurationUpdateRequest';
import type { ServiceFeeImportData } from '../models/ServiceFeeImportData';
import type { ServiceFeePriceCreateRequest } from '../models/ServiceFeePriceCreateRequest';
import type { ServiceFeePriceUpdateRequest } from '../models/ServiceFeePriceUpdateRequest';
import type { TeamVehicleCreateRequest } from '../models/TeamVehicleCreateRequest';
import type { TeamVehicleLuggageCreateRequest } from '../models/TeamVehicleLuggageCreateRequest';
import type { TeamVehicleLuggageUpdateRequest } from '../models/TeamVehicleLuggageUpdateRequest';
import type { TeamVehicleUpdateRequest } from '../models/TeamVehicleUpdateRequest';
import type { VehicleDto } from '../models/VehicleDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class VehicleService {
    /**
     * @param teamCode
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleVehicles(
        teamCode?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/Vehicles',
            query: {
                'teamCode': teamCode,
            },
        });
    }
    /**
     * @param teamId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetVehiclesByTeamId(
        teamId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetVehiclesByTeamId',
            query: {
                'teamId': teamId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleUpdateVehicle(
        teamId?: number,
        requestBody?: VehicleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/UpdateVehicle',
            query: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleBulkUpdateVehicles(
        teamId?: number,
        requestBody?: Array<VehicleDto>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/BulkUpdateVehicles',
            query: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param vehicleId
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiVehicleDeleteVehicle(
        vehicleId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Vehicle/DeleteVehicle',
            query: {
                'vehicleId': vehicleId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamId
     * @returns any OK
     * @throws ApiError
     */
    public static postApiVehicleImportDefaultVehicles(
        teamId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Vehicle/ImportDefaultVehicles',
            query: {
                'teamId': teamId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleHolidays(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/Holidays',
        });
    }
    /**
     * @param city
     * @param airportId
     * @param teamId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetSuburbanFeeData(
        city?: string,
        airportId?: string,
        teamId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetSuburbanFeeData',
            query: {
                'city': city,
                'airportID': airportId,
                'teamId': teamId,
            },
        });
    }
    /**
     * @param teamId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetAllTeamVehicles(
        teamId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetAllTeamVehicles',
            query: {
                'teamId': teamId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetTeamVehicle(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetTeamVehicle/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiVehicleCreateTeamVehicle(
        requestBody?: TeamVehicleCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Vehicle/CreateTeamVehicle',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleUpdateTeamVehicle(
        id: number,
        requestBody?: TeamVehicleUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/UpdateTeamVehicle/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiVehicleDeleteTeamVehicle(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Vehicle/DeleteTeamVehicle/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamVehicleId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetTeamVehicleLuggages(
        teamVehicleId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetTeamVehicleLuggages/{teamVehicleId}',
            path: {
                'teamVehicleId': teamVehicleId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetTeamVehicleLuggage(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetTeamVehicleLuggage/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiVehicleCreateTeamVehicleLuggage(
        requestBody?: TeamVehicleLuggageCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Vehicle/CreateTeamVehicleLuggage',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleUpdateTeamVehicleLuggage(
        id: number,
        requestBody?: TeamVehicleLuggageUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/UpdateTeamVehicleLuggage/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiVehicleDeleteTeamVehicleLuggage(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Vehicle/DeleteTeamVehicleLuggage/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamVehicleId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleBulkUpdateTeamVehicleLuggages(
        teamVehicleId: number,
        requestBody?: Array<TeamVehicleLuggageCreateRequest>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/BulkUpdateTeamVehicleLuggages/{teamVehicleId}',
            path: {
                'teamVehicleId': teamVehicleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamId
     * @param airportId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetServiceFeeConfigurations(
        teamId?: number,
        airportId?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetServiceFeeConfigurations',
            query: {
                'teamId': teamId,
                'airportID': airportId,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetServiceFeeConfiguration(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetServiceFeeConfiguration/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param airportId
     * @param city
     * @param teamId
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetServiceFeeData(
        airportId?: string,
        city?: string,
        teamId?: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetServiceFeeData',
            query: {
                'airportID': airportId,
                'city': city,
                'teamId': teamId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiVehicleCreateServiceFeeConfiguration(
        requestBody?: ServiceFeeConfigurationCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Vehicle/CreateServiceFeeConfiguration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleUpdateServiceFeeConfiguration(
        id: number,
        requestBody?: ServiceFeeConfigurationUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/UpdateServiceFeeConfiguration/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiVehicleDeleteServiceFeeConfiguration(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Vehicle/DeleteServiceFeeConfiguration/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiVehicleCreateServiceFeePrice(
        requestBody?: ServiceFeePriceCreateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Vehicle/CreateServiceFeePrice',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiVehicleGetServiceFeePrice(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Vehicle/GetServiceFeePrice/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleUpdateServiceFeePrice(
        id: number,
        requestBody?: ServiceFeePriceUpdateRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/UpdateServiceFeePrice/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiVehicleDeleteServiceFeePrice(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/Vehicle/DeleteServiceFeePrice/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param configurationId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiVehicleBulkUpdateServiceFeePrices(
        configurationId: number,
        requestBody?: Array<ServiceFeePriceCreateRequest>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Vehicle/BulkUpdateServiceFeePrices/{configurationId}',
            path: {
                'configurationId': configurationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @param teamId
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiVehicleImportServiceFeeData(
        teamId?: number,
        requestBody?: Array<ServiceFeeImportData>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/Vehicle/ImportServiceFeeData',
            query: {
                'teamId': teamId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
